var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time-report" }, [
    _c("section", { staticClass: "report-metrics" }, [
      _c("div", { staticClass: "report-metric" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("timetrack.reports.total-time")))]),
        _c("strong", [
          _vm._v(_vm._s(_vm.$formatters.formatSeconds(_vm.metrics.totalTime)))
        ])
      ]),
      _c("div", { staticClass: "report-metric" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("timetrack.reports.avg-month")))]),
        _c("strong", [
          _vm._v(
            _vm._s(_vm.$formatters.formatSeconds(_vm.metrics.averageMonthTime))
          )
        ])
      ]),
      _c("div", { staticClass: "report-metric" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("timetrack.reports.avg-week")))]),
        _c("strong", [
          _vm._v(
            _vm._s(_vm.$formatters.formatSeconds(_vm.metrics.averageWeekTime))
          )
        ])
      ])
    ]),
    _c(
      "section",
      { staticClass: "report-chart" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.$t("timetrack.reports.monthly-hours")))]),
        _c("time-by-month", { attrs: { "timer-events": _vm.timerEvents } })
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "report-chart" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.$t("timetrack.reports.time-by-project")))]),
        _c("time-by-project", { attrs: { "timer-events": _vm.timerEvents } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }